import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { cn } from '@/lib/utils'
import { ComponentProps, ReactNode } from 'react'

type Option = string | { value: string; label: ReactNode; disabled?: boolean }

type ViverseRadioProps = Omit<ComponentProps<typeof RadioGroup>, 'onValueChange' | 'value'> & {
  options: Option[]
  onValueChange: (value: string) => void
  value?: string
  wrapperClassName?: string
  optionRowClassName?: string
  radioItemClassName?: string
  labelClassName?: string
}

export default function ViverseRadio({
  options,
  onValueChange,
  value,
  wrapperClassName,
  optionRowClassName,
  radioItemClassName,
  labelClassName,
  className,
  ...props
}: ViverseRadioProps) {
  return (
    <div className={cn('flex w-fit items-center gap-[16px]', wrapperClassName)}>
      <RadioGroup
        value={value}
        onValueChange={onValueChange}
        className={cn('flex flex-col', className)}
        {...props}
      >
        {options.map((option, index) => {
          const normalized = typeof option === 'string' ? { value: option, label: option } : option
          const id = `radio-option-${index}-${normalized.value}`

          return (
            <div
              key={id}
              className={cn('flex items-center gap-[12px] py-[10px]', optionRowClassName)}
            >
              <RadioGroupItem
                id={id}
                value={normalized.value}
                disabled={normalized.disabled}
                className={cn(
                  'border-vive-primary-70 bg-vive-primary-70 size-[20px] border-[1.5px] ' +
                    'hover:bg-vive-primary-60 data-[state=checked]:border-primary' +
                    '*:fill-current *:text-current data-[state=checked]:border-[1.5px]',
                  radioItemClassName,
                )}
              />
              <Label htmlFor={id} className={cn('body-1', labelClassName)}>
                {normalized.label}
              </Label>
            </div>
          )
        })}
      </RadioGroup>
    </div>
  )
}
